import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

function generateUniqueId() {
  return uuidv4();
}

function getSessionId() {
  let sessionId = sessionStorage.getItem("sessionId");
  if (!sessionId) {
    sessionId = generateUniqueId();
    sessionStorage.setItem("sessionId", sessionId);
  }
  return sessionId;
}

export function useBrowserSessionId() {
  const [sessionId, setSessionId] = useState<string | null>(null);

  useEffect(() => {
    if (window) {
      const id = getSessionId();
      setSessionId(id);
    }
  }, []);

  return sessionId;
}
